<template>
  <div>
    <b-modal v-model="is_modal_active" :can-cancel="true" :aria-modal="true">
      <div class="card">
        <div class="card-content">
          <div class="media">
            <div class="media-content is-flex is-justify-content-center is-clipped">
              <span class="title is-4">{{ $t('cart.modal.added-to-cart') }}</span>
            </div>
          </div>

          <table class="table is-fullwidth is-vertical-centered" style="margin-bottom: 0;">
            <thead>
            <tr>
              <th class="has-text-start">Product name</th>
              <th>Quantity</th>
              <th>Price</th>
            </tr>
            </thead>
            <tbody>

            <tr v-for="product in products" :key="product.id">
              <td>
                <div class="is-flex is-align-items-center my-2">
                  <a :title="$t('cart.remove')" href="#" class="is-hidden-touch desktop-delete-button" @click.prevent="removeFromCart(product)">
                    <i class="fa fa-remove color-is-grey-light"/>
                  </a>
                  <a :title="$t('cart.remove')" href="#" class="is-hidden-desktop" style="font-size: 1rem;" @click.prevent="removeFromCart(product)">
                    <i class="fa fa-remove color-is-grey-light"/>
                  </a>
                  <figure class="is-hidden-touch image product-image-borders">
                    <img :src="product.images['16by9']" class="has-ratio" style="max-width: 110px;" alt="">
                  </figure>
                  <a :href="product.url" title="View product" class="is-hidden-touch product-title mx-5 has-text-weight-bold">
                    {{ product.name }}
                  </a>
                  <a :href="product.url" title="View product" class="is-hidden-desktop product-title mx-2 has-text-weight-bold" style="font-size: 0.7rem;">
                    {{ product.name }}
                  </a>
                </div>
              </td>
              <td>

                <div class="is-flex is-align-items-center responsive-quantity">
                  <input
                    v-model="product.quantity"
                    type="number"
                    class="qty has-text-weight-bold cart-input"
                    min="1"
                    @input="updateQty(product, $event)"/>
                  <i class="fa fa-solid fa-border fa-sort-up i-arrow"
                     style="margin-bottom: 22px; border-width: 2px 2px 0 2px; border-radius: 0 20% 0 0;"
                     @click="addToCart({ product_id: product.id, quantity: 1 })">
                  </i>
                  <i class="fa fa-solid fa-border fa-sort-down i-arrow"
                     style="margin-top: 22px; border-width: 0 2px 2px 2px; border-radius: 0 0 20% 0;"
                     @click="addToCart({ product_id: product.id, quantity: -1 })">
                  </i>
                </div>
              </td>
              <td>
                <div class="is-flex is-align-items-center is-justify-content-start" style="white-space: nowrap;" >
                  <span class="has-text-weight-bold price" v-html="formatPrice(product.price, product.quantity)"></span>
                </div>
              </td>
            </tr>
            </tbody>
          </table>

          <div class="content">
            <hr style="margin: 0;">
            <div class="is-flex is-justify-content-center mt-2">
              <button v-if="products.length" class="button is-warning" @click="goToCart">
                <i class="fa fa-shopping-cart"></i>&nbsp;
                {{ $t('cart.modal.proceed-to-checkout') }}
              </button>
              <span style="width: 30px;"></span>
              <button class="button is-primary" @click="closeModal">
                {{ $t('cart.modal.continue-shopping') }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<style scoped lang="scss">
@import "bulma/sass/utilities/mixins";


.responsive-quantity{
  @include mobile {
    transform: scale(0.7);
  }
  @include tablet {
    transform: scale(0.8);
  }
  @include desktop {
    transform: scale(0.9);
  }
}
.i-arrow {
  position: absolute;
  font-size: x-large;
  margin-left: 40px;
  color: #f9800e;
  height: 38px;
}
.i-arrow:hover {
  color: #a9540a;
}
.desktop-delete-button{
  position: relative;
  left: -10px;
  z-index: 2;
}
.fa-border{
  border-width: 1.5px 2px 1.6px 2px;
  border-radius: 0 20% 20% 0;
}
.cart-input {
  border:1px solid #eee;
  border-width: 2px 0 2px 2px;
  border-radius: 20% 0 0 20%;
  font-size: 1rem;
  width: 40px;
  height: 60px;
  text-align: center;
    &:focus {
      outline: none !important;
    }
    //hide input arrows Chrome, Safari, Edge, Opera
    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
  }
    //hide input arrows Firefox
    &[type=number] {
      -moz-appearance: textfield;
    }
}
.price{
  display: inline;
  font-size: 16px;
  font-family: Raleway, sans-serif;
  font-weight: 400;
  line-height: 24px;
  color: rgb(88, 97, 114);
}

.product-title {
  color: #6e798f !important;
  font-size: 1rem;
  font-weight: 500;
}
.product-image-borders {
  box-shadow: 1px 2px 6px -2px #6e798f;
  -webkit-box-shadow: 1px 2px 6px -2px #6e798f;
  -moz-box-shadow: 1px 2px 6px -2px #6e798f;
}
</style>

<script>

import Cart from '../../mixins/Cart';
import _ from 'lodash';

export default {
  name: 'AddedToCartModal',
  mixins: [Cart],
  data() {
    return {
      is_modal_active: false,
      cart_url: '/cart'
    };
  },
  mounted() {
    VueEventHub.$on('open-added-to-cart-modal', this.openModal);
    VueEventHub.$on('close-added-to-cart-modal', this.closeModal);
  },
  methods: {
    openModal() {
      if (window.location.pathname !== this.cart_url) {
        this.is_modal_active = true;
      }
    },
    goToCart() {
      window.location.href = '/cart';
    },
    closeModal() {
      this.is_modal_active = false;
    },
    updateQty: _.debounce(function t(product, event) {
      this.addToCart({
        product_id: product.id,
        quantity: parseInt(event.target.value, 10),
        update: true
      });
    }, 500)
  }
};
</script>
